export default "__VITE_ASSET__ClqB4ddY__"